import '../styles/hamburger.css';
import '../styles/Global.css';
import { Link } from 'react-router-dom'; // Import Link for routing

export default function Hamburger({ isOpen }) {
    return (
        <div>
            <div className="hamburger">
                <div className={`burger burger1 ${isOpen ? 'open' : ''}`} />
                <div className={`burger burger2 ${isOpen ? 'open' : ''}`} />
                <div className={`burger burger3 ${isOpen ? 'open' : ''}`} />
            </div>

            <div className={`menuHolder ${isOpen ? 'open' : ''}`}>
                <Link to="/"><button className="ham-menu-button"><span>HOME</span></button></Link>
                <Link to="/Tutorial-Archive"><button className="ham-menu-button"><span>TUTORIAL ARCHIVE</span></button></Link>
                <Link to="/Dev-Team"><button className="ham-menu-button"><span>5TH STEP GAMES</span></button></Link>
                    <Link to="/Game-Progress"><button className="ham-menu-button"><span>GAME PROGRESS</span></button></Link>
                        <Link to="/Work-With-Us"><button className="ham-menu-button"><span>WORK WITH US</span></button></Link>
                {/* <Link to="/About-Poly"><button className="ham-menu-button"><span>ABOUT POLY</span></button></Link> */}
                <Link to="https://store.steampowered.com/app/2734590/Poly_Beats/"><button className="ham-special-menu-button"><span>WISHLIST POLY BEATS</span></button></Link>
            </div>
        </div>
);
}
